<template>
  <div class="mini-footer">
    <div class="left-side">
      <a :href="routes['faqs']">{{ trans.get("layouts.footer.payment") }}</a>
      <a :href="routes['faqs']">{{ trans.get("layouts.footer.faq") }}</a>
    </div>
    <div class="right-side">
      <a :href="routes['legal-disclaimer']">{{ trans.get("layouts.footer.legal") }}</a>
      <a :href="routes['cookies-policy']">{{trans.get('layouts.footer.privacy-policy-cookies')}}</a>
      <a :href="routes['limitation-of-liability']">{{ trans.get("layouts.footer.limit") }}</a>
      <a class="lowercase" :href="routes['shipping-and-delivery']">{{ trans.get("layouts.footer.shipping") }}</a>
      <a class="lowercase" :href="routes['returns-policy']">{{ trans.get("layouts.footer.returns") }}</a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    routes: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss">
@import "../../../sass/variables";
.mini-footer {
  display: flex;
  background-color: $secondary;
  padding: 1rem;
  color: white;
  justify-content: space-between;
  flex-wrap: wrap;
  flex-wrap: wrap;
  gap: .8rem;
  align-items: center;
  a {
    padding: 0.45rem 1rem;
  }

  .left-side{
    a{
      font-weight: bold;
    }
  }

  @media (max-width: $breakpoint-landing-tablet) {
    flex-direction: column;

    .left-side,
    .right-side {
      display: flex;
      width: 100%;
      justify-content: center;
    }
  }
  @media (max-width: $breakpoint-landing-phone) {
    flex-direction: column;

    .left-side,
    .right-side {
      display: flex;
      flex-direction: column;
      width: 100%;
      justify-content: flex-start;
    }
  }

  @media (min-width: $breakpoint-landing-tablet) {
    justify-content: space-between;
    height: 90px;
    padding: 1rem 60px;
  }
}
</style>
